import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { QuotationActions } from 'app/store/data/quotation';
import { ReferralActions } from 'app/store/data/referral';
import { logout as logoutAction } from 'app/store/data/user';
import { ThunkAnyDispatch } from 'app/store/helpers';
import { FormsConfigActions } from 'app/store/data/formsConfig';
import { FormsEnum } from 'app/shared/enums';

export function useLogout(routeAfterLogout: string) {
  const dispatch = useDispatch<ThunkAnyDispatch>();
  const history = useHistory();

  return () => {
    dispatch(QuotationActions.clearQuotation());
    dispatch(
      FormsConfigActions.setFormConfigClearAction(FormsEnum.CalculationForm)
    );
    dispatch(FormsConfigActions.setFormConfigClearAction(FormsEnum.OfferForm));
    dispatch(ReferralActions.clearReferral());
    dispatch(logoutAction()).then(() => {
      history.push(routeAfterLogout);
    });
  };
}
